/*
*###############################################################################
*Module Name                   : DPTagPop.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import MetaTags from 'react-meta-tags'
import "../../assets/scss/datatables.scss"
import BC from '../../assets/images/support/bc.png'

// datatable related plugins
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
    PaginationProvider, PaginationListStandalone,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

const DPTagPop = (props) => {

    return (
        <div>
            <Modal
                size="md"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{props.SubTitle} </CardTitle>
                                    <Row>
                                        <Col className="col-3">
                                            </Col>
                                        <Col className="col-6" style={{
                                            backgroundImage: `url(${props.ImgSrc})`,
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                            minHeight: '300px',
                                        }}>
                                            <Row ><Col className="col-6" style={{minHeight:"205px"}}>{" "}</Col></Row>
                                            <center><div style={{fontSize:"22px"}}>{`Rs.${props.Price}`}</div></center>
                                            <div style={{textAlign: "center"}}>{props.Description}</div>
                                            <center><img src={BC} width={"100px"} height={"40px"} /></center>
                                            <div style={{textAlign: "center"}}>{props.Code}</div>
                                            {/*<img src={props.ImgSrc} alt={props.ImgSrc} width={props.width} height={props.height} />*/}
                                        </Col>
                                            <Col className="col-3">
                                            </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-12">
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    );
}

export default DPTagPop;